import { useEffect } from 'react';

import { Link, useParams } from 'react-router-dom';

import AfterCopyritghtSupervisorControlForm from './AfterCopyritghtSupervisorControlForm';

function AfterCopyrightSupervisorControlView() {
  const { offerID } = useParams();

  useEffect(() => {
    document.getElementById('scrollToTop').scrollIntoView(true);
  }, []);

  return (
    <div id="scrollToTop">
      <Link
        className="ant-btn"
        to={`/madde-detay/${offerID}`}
      >
        Geri
      </Link>
      <AfterCopyritghtSupervisorControlForm offerID={offerID} />
    </div>
  );
}
export default AfterCopyrightSupervisorControlView;
